import api from "./api";

export const trackEvent = (event, source) => {
    const sid = sessionStorage.getItem("ai_sid") || "";
    const body = { event, session_id: sid };
    if (source) body.source = source;
    api.post("/track/event", body).catch(() => {});
    try {
        if (window.fbq) window.fbq("trackCustom", event, source ? { source } : undefined);
    } catch { /* noop */ }
};

export const isPlanRequired = (err) =>
    err?.response?.status === 402 &&
    ["no_plan", "trial_expired"].includes(err?.response?.data?.detail?.reason);
